import type { LocaleCodeType } from 'typings/languageTypes'

export const codeDefaultLocale: LocaleCodeType = 'en-US'
export const codeUnknownLocale = 'int'
